<template>
  <v-col>
    <Teacher :is-edit="isEdit" @teacherUpdate="teacherUpdate"></Teacher>
  </v-col>
</template>

<script>
import api from '@/mixins/api'
import Teacher from '@/components/hps/Teacher'

export default {
  name: 'hps_teacher_create_edit',
  components: { Teacher },
  data() {
    return {}
  },
  computed: {
    isEdit() {
      return 'id' in this.$route.params
    },
  },
  mounted() {},
  methods: {
    teacherUpdate(teacher) {
      this.$router.push({ name: 'hps_teachers_edit', params: { id: teacher.id } })
    },
  },
}
</script>
